import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { ModalsKeys } from '~/types/uiTypes';
import { Modal as UiModal, ModalProps } from '@aqarmap/aqarmap-ui';

export default function Modal({
  children,
  modalKey,
  ...rest
}: Omit<ModalProps<ModalsKeys>, 'handleCloseModal'>) {
  const { modals } = useAppSelector((state) => state.uiState);
  const dispatch = useAppDispatch();

  return (
    <UiModal
      open={modals[modalKey]}
      modalKey={modalKey}
      {...rest}
      handleCloseModal={() => {
        dispatch(closeModal(modalKey));
      }}
    >
      {children}
    </UiModal>
  );
}
